export default __webpack_public_path__ + "static/media/at.6c2c7f6d.svg";